/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-11T10:54:45.835
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentHouseHoldItem,
	listRentHouseHoldItemInit,
	listRentHouseHoldItemByAuthorizations,
	deleteRentHouseHoldItem,
	downloadTemplate
} from '@api/rentmanage/RentHouseHoldItem';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentHouseHoldItem({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseHoldItem(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseHoldItemByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseHoldItemByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseHoldItemInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseHoldItemInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		downloadRentHouseHoldItemTemplate({
			dispatch,
			state,
		}, data) {
			return new Promise((resolve, reject) => {
				downloadTemplate(data)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteRentHouseHoldItem({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentHouseHoldItem({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
